import { render, staticRenderFns } from "./OrganizationEditPermission.vue?vue&type=template&id=4ded8d6b&"
import script from "./OrganizationEditPermission.vue?vue&type=script&lang=js&"
export * from "./OrganizationEditPermission.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports